<h4 style="text-align:center;">Under Construction: wait</h4>
<p>
    This is a generated scaffold for the 'wait' component.
</p>
